import React, { useEffect } from "react";
import "./report.css";
import { Button, Dialog, DialogActions, DialogContent, useTheme } from "@mui/material";
import { getSinglePaymentVoucher } from "state/apis";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { numberToWords } from "utils/constants";

const PaymentVoucherDetails = ({ open, onClose, onSubmit, editData, editMode }) => {
    const theme = useTheme();
    const [isLoading, setIsLoading] = React.useState(true);
    const [data, setData] = React.useState({});

    useEffect(() => {
        if (editData?.id) {
            fetchData();
        }
    }, [editData, editMode]);

    const fetchData = async () => {
        try {
            const res = await getSinglePaymentVoucher(editData.id);
            setData(res?.voucher);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to fetch data. Please try again.");
        }
    };

    const reportRef = React.useRef();

    const handlePrint = () => {
        const input = reportRef.current;

        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const margin = 10; // Add margin (padding)

            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;

            let heightLeft = imgHeight;
            let position = margin;

            pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
            heightLeft -= pdfHeight - 2 * margin;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight + margin;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
                heightLeft -= pdfHeight - 2 * margin;
            }

            pdf.save(`payment_voucher.pdf`);
        });
    };
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent style={{ width: "600px", padding: "20px" }}>
                <div ref={reportRef}>
                    <div
                        style={{
                            whiteSpace: "nowrap",
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <div style={{ textAlign: "start", marginTop: "4px" }}>
                            <p className="p-style">P.O. Box: 6390,</p>
                            <p className="p-style">Sharjah - U.A.E</p>
                            <p className="p-style">Tel: 06-5222877</p>
                        </div>

                        <div style={{ textAlign: "center", marginBottom: "10px" }}>
                            <h2 className="p-style">{data?.property?.owner?.arabicName}</h2>
                            <h4 className="p-style" style={{ fontSize: "14px" }}>
                                {data?.property?.owner?.name}
                            </h4>
                            <h5 className="p-style">E-mail: burgancenter@gmail.com</h5>
                        </div>

                        <div style={{ textAlign: "end", marginTop: "4px" }}>
                            <p className="p-style">ص.ب : 6390</p>
                            <p className="p-style">الشارقة – ا.ع.م</p>
                            <p className="p-style">تليفون:-٠٦٥٢٢٢٨٧٧</p>
                        </div>
                    </div>
                    <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                position: "relative",
                            }}
                        >
                            <h4 style={{ margin: "0" }}>
                                <span>Date:</span>
                                <span
                                    style={{
                                        borderBottom: "1px dotted black",
                                        paddingLeft: "5px",
                                    }}
                                >
                                    {data?.date ? moment(data?.date).format("DD-MM-YYYY") : ""}
                                </span>
                                <span style={{ paddingLeft: "10px" }}>: التاريخ</span>
                            </h4>

                            <h2
                                style={{
                                    position: "absolute",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    margin: "0",
                                }}
                            >
                                سند صرف
                            </h2>
                        </div>

                        <h4
                            style={{
                                margin: "0",
                                textDecoration: "underline",
                                textAlign: "center",
                            }}
                        >
                            Payment Voucher
                        </h4>
                    </div>

                    <div style={{ marginBottom: "20px" }}>
                        <p className="p-style">
                            Narration:{" "}
                            <span
                                style={{
                                    display: "inline-block",
                                    borderBottom: "1px dotted black",
                                    width: "80%",
                                }}
                            >
                                {data?.note}
                            </span>
                            <span style={{ textAlign: "end" }}> للتقرير</span>
                        </p>
                    </div>

                    <div style={{ padding: "8px", border: "1px solid" }}>
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                marginBottom: "0px",
                                border: "1px solid black",
                            }}
                        >
                            <tbody style={{ padding: "5px", border: "none" }}>
                                <tr>
                                    <td
                                        colSpan={10}
                                        className="no-border p-style"
                                        style={{ padding: "10px" }}
                                    >
                                        Received From:{" "}
                                        <span style={{ fontWeight: "bold" }}>
                                            {data?.property?.owner?.name}{" "}
                                        </span>
                                        {data?.property?.owner?.arabicName}
                                    </td>
                                    <td
                                        className="p-style"
                                        style={{
                                            padding: "10px",
                                            border: "none",
                                            textAlign: "center",
                                        }}
                                    >
                                        درهم
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        colSpan={10}
                                        className="no-border p-style"
                                        style={{ padding: "10px", border: "none" }}
                                    >
                                        The Sum of:{" "}
                                        <span
                                            style={{
                                                display: "inline-block",
                                                borderBottom: "1px dotted black",
                                                width: "75%",
                                            }}
                                        >
                                            {numberToWords(parseInt(data?.totalAmount)) + " Only"}
                                        </span>
                                        <span style={{ textAlign: "end" }}>مبلغ</span>
                                    </td>
                                    <td colSpan={10} style={{ padding: "10px", border: "none" }}>
                                        {`${data?.totalAmount}/-`}
                                    </td>
                                </tr>

                                <tr>
                                    <td
                                        colSpan={10}
                                        className="no-border p-style"
                                        style={{ padding: "10px", border: "none" }}
                                    >
                                        For:{" "}
                                        <span
                                            style={{
                                                display: "inline-block",
                                                borderBottom: "1px dotted black",
                                                width: "83%",
                                            }}
                                        >
                                            {data?.description}
                                        </span>
                                        <span style={{ textAlign: "end" }}>وذالك من</span>
                                    </td>
                                    <td style={{ padding: "10px", border: "none" }}></td>
                                </tr>
                                <tr>
                                    <td
                                        colSpan={10}
                                        className="no-border"
                                        style={{ padding: "10px", border: "none" }}
                                    >
                                        <span
                                            style={{
                                                display: "inline-block",
                                                borderBottom: "1px dotted black",
                                                width: "100%",
                                            }}
                                        ></span>
                                    </td>
                                    <td style={{ padding: "10px", border: "none" }}></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Signatures */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "20px",
                        }}
                    >
                        <div>
                            <p>___________________</p>
                            <p style={{ textAlign: "center" }}>Prepared by</p>
                        </div>
                        <div>
                            <p>___________________</p>
                            <p style={{ textAlign: "center" }}>Approved by</p>
                        </div>
                        <div>
                            <p>___________________</p>
                            <p style={{ textAlign: "center" }}>Received by</p>
                        </div>
                    </div>
                </div>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={handlePrint}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Print
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default PaymentVoucherDetails;
